import { Pipe, PipeTransform } from '@angular/core';
import { LegalCounselService } from '../legal-counsel/legal-counsel.service';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'asyncLegalCounselAll'
})
export class AsyncLegalCounselPipeAll implements PipeTransform {
  constructor(private legalCounselService: LegalCounselService) {}

  transform(input: any) {
      return this.legalCounselService
          .getAll()
          .pipe(
              map(v =>
                  v.sort((a, b) => (a["fullname"].toLowerCase() > b["fullname"].toLowerCase() ? 1 : -1))
              )
          );
  }

}
